export class DataSourceFilter implements IFilteringRequest, IPaginationRequest, ISortingRequest {
  filter: Filter = {} as Filter;
  sortBy: string;
  page: number;
  pageSize: number;
}
export declare type FilterOperator = 'contains' | 'startswith' | 'endswith' | 'lte' | 'gte' | 'lt' | 'gt' | 'eq' | 'neq';
export interface Filter {
  field: string;
  operator?: FilterOperator;
  value: any;
  logic?: string;
  filters?: Filter[];
}

export interface IFilteringRequest {
  filter: Filter;
}

export interface IPaginationRequest {
  page: number;
  pageSize: number;
}
export interface ISortingRequest {
  sortBy: string;
}
